import { api, setConfig } from '../..';
import { mapEntityToApi } from './mapper';
import { PropertyType } from '../../../common';

export const getAverageRates = (data: PropertyType): Promise<PropertyType> =>
	api.post('/currencies-avg-rate', mapEntityToApi(data), setConfig(data)).then((res) => {
		return res.data.data;
	});
